// @flow

import React from 'react';
export function CartNotiIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.1 2C2.76863 2 2.5 2.26863 2.5 2.6C2.5 2.93137 2.76863 3.2 3.1 3.2H3.7V10.5024C3.00088 10.7495 2.5 11.4163 2.5 12.2C2.5 13.1941 3.30589 14 4.3 14C5.29411 14 6.1 13.1941 6.1 12.2C6.1 11.9896 6.06391 11.7877 5.99758 11.6H9.20242C9.13609 11.7877 9.1 11.9896 9.1 12.2C9.1 13.1941 9.90589 14 10.9 14C11.8941 14 12.7 13.1941 12.7 12.2C12.7 11.2059 11.8941 10.4 10.9 10.4H4.9V9.2H11.8398C12.2877 9.2 12.6674 8.87066 12.7308 8.42728L13.294 4.48485C13.3408 4.15681 13.1129 3.85289 12.7849 3.80603C12.4568 3.75917 12.1529 3.98711 12.106 4.31515L11.5796 8H4.9V2.9C4.9 2.40294 4.49706 2 4 2H3.1ZM10.9 11.6C10.5686 11.6 10.3 11.8686 10.3 12.2C10.3 12.5314 10.5686 12.8 10.9 12.8C11.2314 12.8 11.5 12.5314 11.5 12.2C11.5 11.8686 11.2314 11.6 10.9 11.6ZM4.3 11.6C3.96863 11.6 3.7 11.8686 3.7 12.2C3.7 12.5314 3.96863 12.8 4.3 12.8C4.63137 12.8 4.9 12.5314 4.9 12.2C4.9 11.8686 4.63137 11.6 4.3 11.6Z"
        fill="#8C9196"
      />
      <path
        d="M8.5605 0.5C8.73722 0.5 8.8805 0.643269 8.8805 0.82V1.46L8.88034 1.47014L8.88003 1.47709L8.8794 1.48637C9.788 1.63827 10.4805 2.42827 10.4805 3.38C10.4805 4.36987 10.6805 4.75983 10.9921 5.36729L11.0032 5.38899C11.0575 5.49482 10.9806 5.62 10.8616 5.62H6.2594C6.14042 5.62 6.06354 5.49482 6.11784 5.38899L6.12893 5.36729C6.4405 4.75983 6.6405 4.36987 6.6405 3.38C6.6405 2.42827 7.333 1.63827 8.24159 1.48637L8.24089 1.47371C8.24065 1.46916 8.2405 1.46459 8.2405 1.46V0.82C8.2405 0.643269 8.38378 0.5 8.5605 0.5Z"
        fill="#8C9196"
      />
      <path
        d="M9.2005 6.26C9.2005 6.61346 8.91393 6.9 8.5605 6.9C8.20706 6.9 7.9205 6.61346 7.9205 6.26H9.2005Z"
        fill="#8C9196"
      />
    </svg>
  );
}
